import { Button, Typography } from "@mui/material";

import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "~/app/store";

import { mixpanelTrack, useMixpanelPageName } from "~/lib/mixpanel-tracking";

import { MovePickDialog } from "./MovePickDialog";
import { setIsTransferModalOpen, setTransferQty } from "./shipOrder.slice";

export function MovePickButton() {
  const trackedPageName = useMixpanelPageName();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const isTransferModalOpen = useAppSelector(
    (state) => state.shipOrder.isTransferModalOpen
  );
  const selectedPick = useAppSelector((state) => state.shipOrder.selectedPick);
  return (
    <>
      <Button
        color="secondary"
        onClick={() => {
          mixpanelTrack({
            trackedPageName,
            type: "Button Click",
            label: "Move To Existing Tote",
            eventProperties: {
              "Pick ID": selectedPick?.pickId
            }
          });
          dispatch(setTransferQty(null));
          dispatch(setIsTransferModalOpen(!isTransferModalOpen));
        }}
      >
        <Typography variant="body2" style={{ color: "#fff" }}>
          {t("move to existing tote")}
        </Typography>
      </Button>
      <MovePickDialog />
    </>
  );
}
